<template>
  <div v-if="value" class="py-1">
    <dt class="text-xs font-medium text-gray-500 dark:text-gray-400">{{ label }}</dt>
    <dd class="mt-0.5 text-sm text-gray-900 dark:text-gray-100">{{ value }}</dd>
  </div>
</template>

<script setup>
defineProps({
  label: { type: String, required: true },
  value: { type: [String, Number], default: null }
})
</script>
